export default function PasswordRenderer() {
  return "******";
}
